<template>
  <div :class="$style.wrap">
    <h1>{{ title }}</h1>
    <p v-for="(text, index) in desc" :key="index">{{ text }}</p>
    <p>
      {{ $t("contact.before") }}
      <a
        href="https://chaten.sobot.com/chat/h5/v2/index.html?sysnum=aba44a7f03774e21b112e582f74ca5a2"
        target="_blank"
      >
        {{ $t("contact.server") }}
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      title: "",
      desc: [],
    };
  },
  created() {
    const { rdesc, data } = this.$route.query;
    this.title = rdesc;
    this.desc = data.split("|");
  },
  // 未带参数拒绝访问
  beforeRouteEnter(to, from, next) {
    const { rdesc, data, gid, aid } = to.query;
    if (rdesc && data) {
      next();
    } else if (gid && aid) {
      next({ path: "/", query: { gid, aid } });
    } else {
      next({ path: "/map" });
    }
  },
};
</script>

<style lang="less" module>
.wrap {
  padding: @padding-md 0;
  text-align: center;

  h1 {
    font-size: @heading-3-size;
  }

  p {
    color: @text-color-secondary;
  }

  @media (min-width: @screen-md-min) {
    min-height: 600px;
    padding-top: 100px;

    h1 {
      font-size: @heading-2-size;
    }

    p {
      font-size: @font-size-lg;
    }
  }
}
</style>
